import { pickBy } from "@/utils";
import CompsStyle from "../../comps/comps-style.vue";
import navItem from "./nav-item.vue";
import NavSetting from "./nav-setting.vue";
import { cloneDeep } from 'lodash'
import { transformInTem } from "../../utils"

// Base64 编码函数（支持中文和特殊字符）
const encodeToBase64 = (str) => {
  if (!str) return str;
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (e) {
    console.error('Base64 编码失败:', e);
    return str;
  }
};

// Base64 解码函数（支持中文和特殊字符）
const decodeFromBase64 = (str) => {
  if (!str) return str;
  try {
    return decodeURIComponent(escape(atob(str)));
  } catch (e) {
    console.error('Base64 解码失败:', e);
    return str;
  }
};


export default {
  name: "contentPart",
  setting: [
    {
      label: "分区交互",
      key: "animate",
      component: "radiobutton",
      options: [
        { name: "分区纵向", label: "0" },
        { name: "分区横向", label: "1" },
        { name: "分区切屏", label: "2" },
      ],
      value: "0",
      module: "",
    },
    {
      label: "导航展示",
      key: "showNav",
      component: "radiobutton",
      options: [
        { name: "显示", label: 1 },
        { name: "隐藏", label: 0 },
      ],
      value: 1,
      module: "",
    },
    {
      label: "吸顶",
      key: "fixedTop",
      component: "radiobutton",
      options: [
        { name: "是", label: 1 },
        { name: "否", label: 0 },
      ],
      value: 1,
      isShow: function () {
        return this.value.showNav == 1;
      },
      module: "",
    },
    {
      label: "吸顶样式",
      key: "isSameStyle",
      component: "radiobutton",
      options: [
        { name: "一致", label: 1 },
        { name: "不一致", label: 0 },
      ],
      value: 1,
      isShow: function () {
        return this.value.showNav == 1 && this.value.fixedTop == 1;
      },
      onchange: (val, that) => {
        if (val == 1) {
          that.value.navsetting = 0;
          that.value.immersiveSwitch = 1
        }else {
          that.value.immersiveSwitch = 0
        }
      },
      module: "",
    },
    {
      label: '沉浸式开启',
      key: 'immersiveSwitch',
      component: 'radiobutton',
      options: [
        { name: '是', label: 1 },
        { name: '否', label: 0 },
      ],
      value: 1,
      module: "",
      isShow: function () {
        return this.value.showNav == 1 && this.value.fixedTop == 1 && this.value.isSameStyle == 1;
      },
    },
    {
      label: "",
      key: "navsetting",
      component: function (h, { key }) {
        return (
          <el-button-group style="margin-left: -80px;margin-top: 10px;display: flex;width: calc(100% + 80px);">
            <el-button
              style="flex:1"
              size="mini"
              type="primary"
              plain={this.value.navsetting == 1}
              onclick={(el) => {
                this.value[key] = this.value[key] == 1 ? 0 : 1;
              }}
            >
              未吸顶样式
            </el-button>
            <el-button
              style="flex:1"
              size="mini"
              type="primary"
              plain={this.value.navsetting == 0}
              onclick={() => {
                this.value[key] = this.value[key] == 1 ? 0 : 1;
              }}
            >
              吸顶样式
            </el-button>
          </el-button-group>
        );
      },
      isShow: function () {
        return this.value.fixedTop == 1 && this.value.isSameStyle == 0;
      },
      value: 0,
      module: "nav",
    },
    {
      label: "",
      key: "fixsetting",
      component: function (h, { key }) {
        return <NavSetting v-model={this.value[key]} immersiveSwitch={this.value.immersiveSwitch} uuid={this.value.uuid} />;
      },
      isShow: function () {
        return this.value.fixedTop == 1 && this.value.navsetting == 1;
      },
      value: {
        navbgtype: 0,
        navtype:'0',
        navbgcolor: "",
        navbgslidervalue: "",
        imgUrl: "",
        imgUrlslider: "",
        navpadded: {
          paddedt: 0,
          paddedb: 0,
          paddedl: 0,
          paddedr: 0,
        },
        immersiveSwitchColorMode: '',
        navbgopacity: 0.55,
        topimgUrlSvg: '',
        navitemjumpconfig: {},
        topimgUrlSvgSearch: '',
        navitemjumpconfigSearch: {},
        navitemtextfontsize: 13,
        navitemtextboldvalue: 800,
        navitemcolor: "",
        navitemcolorSlider: "",
        navitemareapadded: {
          paddedt: 0,
          paddedb: 0,
          paddedl: 0,
          paddedr: 0,
        },
        // navitempadded: {
        //   paddedt: 20,
        //   paddedb: 20,
        //   paddedl: 20,
        //   paddedr: 20,
        // },
        navitemradius: 10,
        navitemHeight: 45,
        slideritempadded: { paddedtb: 0, paddedlr: 0 },
        leftimgUrl: "",
        rightimgUrl: "",
      },
      module: "nav",
    },
    {
      label: "",
      key: "defaultsetting",
      component: function (h, { key }) {
        return <NavSetting v-model={this.value[key]} immersiveSwitch={this.value.immersiveSwitch} uuid={this.value.uuid} />;
      },
      isShow: function () {
        return (
          this.value.fixedTop == 0 ||
          (this.value.fixedTop == 1 && this.value.navsetting == 0)
        );
      },
      value: {
        navbgtype: 0,
        navtype:'0',
        navbgcolor: "",
        navbgslidervalue: "",
        imgUrl: "",
        imgUrlslider: "",
        navpadded: {
          paddedt: 0,
          paddedb: 0,
          paddedl: 0,
          paddedr: 0,
        },
        immersiveSwitchColorMode: '',
        navbgopacity: 0.55,
        topimgUrlSvg: '',
        navitemjumpconfig: {},
        topimgUrlSvgSearch: '',
        navitemjumpconfigSearch: {},
        navitemtextfontsize: 13,
        navitemtextboldvalue: 800,
        navitemcolor: "",
        navitemcolorSlider: "",
        navitemareapadded: {
          paddedt: 0,
          paddedb: 0,
          paddedl: 0,
          paddedr: 0,
        },
        navitemradius: 10,
        navitemHeight: 45,
        slideritempadded: { paddedtb: 0, paddedlr: 0 },
        leftimgUrl: "",
        rightimgUrl: "",
      },
      module: "nav",
    },
    {
      label: "",
      key: "data",
      component: function (h, { key }) {
        return <navItem v-model={this.value[key]} immersiveSwitch={this.value.immersiveSwitch} uuid={this.value.uuid} />;
      },
      value: [],
      module: "navcontent",
    },
  ],
  transformIn: async (v, widgets) => {
    const { name, base, config, data, setting: { defaultsetting, fixsetting } } = v;
    const processSettings = (settings) => ({
      navbgtype: settings.navbgtype || '',
      navtype: settings.navtype || '0',
      navbgcolor: settings.navbgcolor || '',
      navbgslidervalue: settings.navbgslidervalue || '',
      imgUrl: settings.imgUrl || '',
      imgUrlslider: settings.imgUrlslider || '',
      immersiveSwitchColorMode: settings.immersiveSwitchColorMode || '',
      navbgopacity: settings.navbgopacity || 0.55,
      topimgUrlSvg: decodeFromBase64(settings.topimgUrlSvg) || '',
      navitemjumpconfig: settings.navitemjumpconfig || {},
      topimgUrlSvgSearch: decodeFromBase64(settings.topimgUrlSvgSearch) || '',
      navitemjumpconfigSearch: settings.navitemjumpconfigSearch || {},
      navitemtextfontsize: settings.navitemtextfontsize || 13,
      navitemtextboldvalue: settings.navitemtextboldvalue || 800,
      navpadded: {
        paddedt: settings.navpadded?.paddedt || 0,
        paddedb: settings.navpadded?.paddedb || 0,
        paddedl: settings.navpadded?.paddedl || 0,
        paddedr: settings.navpadded?.paddedr || 0,
      },
      navitemcolor: settings.navitemcolor || '',
      navitemcolorSlider: settings.navitemcolorSlider || '',
      navitemareapadded: {
        paddedt: settings.navitemareapadded?.paddedt || 0,
        paddedb: settings.navitemareapadded?.paddedb || 0,
        paddedl: settings.navitemareapadded?.paddedl || 0,
        paddedr: settings.navitemareapadded?.paddedr || 0,
      },
      navitemradius: settings.navitemradius || '',
      navitemHeight: settings.navitemHeight || '',
      slideritempadded: {
        paddedtb: settings.slideritempadded?.paddedtb || 0,
        paddedlr: settings.slideritempadded?.paddedlr || 0,
      },
      leftimgUrl: settings.leftimgUrl || '',
      rightimgUrl: settings.rightimgUrl || '',
    });
    const _data = await transformInTem(data, widgets)
    return {
      name,
      ...base,
      ...config,
      defaultsetting: processSettings(defaultsetting),
      fixsetting: processSettings(fixsetting),
      data: _data,
      navsetting: 0,
    };
  },
  transformOut: (v, widgets) => {
    const value = cloneDeep(v)
    const data = value.data.map(item => {
      const { cusTom, ...rest } = item
      if (cusTom) {
        let _cusTom = null
        const { template = [], pages_template_id, template_title } = cusTom
        _cusTom = {
          pages_template_id,
          template_title,
        }
        return {
          data: _cusTom,
          ...rest
        }
      }
      return item
    })
    value.data = data
    // 保存时将 topimgUrlSvg 和 topimgUrlSvgSearch 转为 Base64
    if (value.fixsetting) {
      value.fixsetting.topimgUrlSvg = encodeToBase64(value.fixsetting.topimgUrlSvg);
      value.fixsetting.topimgUrlSvgSearch = encodeToBase64(value.fixsetting.topimgUrlSvgSearch);
    }
    if (value.defaultsetting) {
      value.defaultsetting.topimgUrlSvg = encodeToBase64(value.defaultsetting.topimgUrlSvg);
      value.defaultsetting.topimgUrlSvgSearch = encodeToBase64(value.defaultsetting.topimgUrlSvgSearch);
    }
    return pickBy(value, {
      name: "name",
      base: (value) => {
        return pickBy(value, {
          animate: "animate", //分区交互
          showNav: "showNav", //导航展示
          fixedTop: "fixedTop", //吸顶
          isSameStyle: 'isSameStyle',
          immersiveSwitch: 'immersiveSwitch'
        });
      },
      setting: (value) => {
        return pickBy(value, {
          fixsetting: "fixsetting",
          defaultsetting: "defaultsetting",
        });
      },
      config: {},
      data: "data",
    });
  },
};
